import React from "react"
import { graphql } from 'gatsby'
import withI18next from "../components/withI18next"
import Layout from "../components/Layout"
import BookingLine from "../components/BookingLine"
import Breadcrumb from "../components/Breadcrumb"
import Contact from "../components/ContactPage"
import { generateSEOData } from "../helpers/seo"

const ContactPage = ({ pageContext: { localeData }, data }) => {

  const { frontmatter: fields } = data.page
  const { childImageSharp: bgImage } = data.bgImage

  // Generate SEO data for contact page
  const seoData = generateSEOData('contact', localeData.locale)

  return (
    <Layout
      localeData={localeData}
      title={fields.title}
      keywords={fields.keywords}
      description={fields.description}
      robots={seoData?.robots}
      canonical={seoData?.canonical}
      hreflang={seoData?.hreflang}
    >
      <BookingLine localeData={localeData} />
      <Breadcrumb slug={fields.slug} title={fields.title} bgImage={bgImage} bgOffset="-80" bgImageOverlay={true} />
      <Contact data={fields} />
    </Layout>
  );
};
export default withI18next()(ContactPage);

export const query = graphql`
  query($id: String!) {
    page: markdownRemark(id: { eq: $id })
    {
      frontmatter {
        slug
        title
        keywords
        description
      }
    }
    bgImage: file(relativePath: { eq: "bg/contact_bg.jpg" }) {
      childImageSharp {
        fluid(quality: 70, maxWidth: 1500) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }`